import HeroSection from '../components/HeroSection'
import AboutSection from '../components/AboutSection'
import ProgramsSection from '../components/ProgramsSection'
import ImpactSection from '../components/ImpactSection'
import CalendarSection from '../components/CalendarSection'

function HomePage() {
    return (
        <>
            <HeroSection />
            <AboutSection />
            <ProgramsSection />
            <ImpactSection />
            <CalendarSection />
        </>
    )
}

export default HomePage
